export default __webpack_public_path__ + "static/media/tech2.5f4531a5.png";